export default {
  text: 'Je verdient <highlight>{{value}} punten</highlight> met deze bestelling',
};
